import React, { useRef } from 'react';
import styled from 'styled-components';
import { Alert } from '@tvg/fuse-design/alert';
import { Link } from '@tvg/fuse-design/link';
import { gridConfig } from '@tvg/fuse-design/responsive-grid';
import IconChevronRight from '@tvg/fuse-icons/lib/ChevronRight';
import FocusTrap from 'focus-trap-react';

const OverlayStyled = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: var(--color-functional-tintBlack20);
`;

const AlertStyled = styled(Alert).attrs({
  'aria-live': 'assertive',
  role: 'alert',
})`
  position: fixed;
  top: var(--spacing-space32);
  left: var(--spacing-space16);
  right: var(--spacing-space16);
  width: auto;

  @media screen and (min-width: ${gridConfig.m.minWidth}) {
    top: var(--spacing-space24);
    left: var(--spacing-space24);
    right: var(--spacing-space24);
  }

  @media screen and (min-width: ${gridConfig.xl.minWidth}) {
    left: 50%;
    right: unset;
    transform: translateX(-50%);
    width: 100%;
  }

  & .fuse-link {
    display: flex;
    margin-top: var(--spacing-space2);
  }
`;

export default function ErrorAlert() {
  const alertRef = useRef();

  return (
    <FocusTrap focusTrapOptions={{ initialFocus: false }}>
      <OverlayStyled>
        <AlertStyled ref={alertRef} heading="Sorry, an error has occurred" showIcon size="responsive" variant="error">
          <Link href="" size="medium" icon={<IconChevronRight />} iconRight underline>
            Please refresh the page
          </Link>
        </AlertStyled>
      </OverlayStyled>
    </FocusTrap>
  );
}
